// Init sliderStates to all show the first image.
let slideShows = document.getElementsByClassName("slideshow-container");

// sliderStates is an array that represents the status of each slideshow. 1 means the first image is shown.
let sliderStates = Array(slideShows.length).fill(1);

// Init all Slides to show the first image
for (let i = 0; i < sliderStates.length; i++) {
    showSlides(1, i);
}

function changeSlideTo(slide, slideShowIndex) {
    showSlides((sliderStates[slideShowIndex] = slide), slideShowIndex);
}

function plusSlides(slide, slideShowIndex) {
    showSlides((sliderStates[slideShowIndex] += slide), slideShowIndex);
}

function showSlides(slide, slideShowIndex) {

    let i;

    let slideClass = "mySlides-" + slideShowIndex;
    let slideImgs = document.getElementsByClassName(slideClass);

    dotClass = "dot-" + slideShowIndex;
    let dots = document.getElementsByClassName(dotClass);

    if (slide > slideImgs.length) {
        sliderStates[slideShowIndex] = 1;
    }
    if (slide < 1) {
        sliderStates[slideShowIndex] = slideImgs.length;
    }
    for (i = 0; i < slideImgs.length; i++) {
        slideImgs[i].style.display = "none";
    }
    for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
    }
    slideImgs[sliderStates[slideShowIndex] - 1].style.display = "block";
    dots[sliderStates[slideShowIndex] - 1].className += " active";
}



/* ---------------------------------------------------------------------------------------------- 
    When the filter is applied, the slides need to be reset. All cards will show the first image
    and the 

    The Modal uses << product-count__text >> for detecting changes. Similar code can be found in 
    custom-modal.js, callback and observer have a 2 attached to them, because otherwise the 
    variables somehow clash with this script. 
 ---------------------------------------------------------------------------------------------- */
let productCounter = document.getElementsByClassName("product-count__text")[0];
const config = { attributes: true, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
        // Rest sliderStates all to 1
        sliderStates = Array(slideShows.length).fill(1);
        for (let i = 0; i < sliderStates.length; i++) {
            showSlides(1, i);
        }
    }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(productCounter, config);
